import {ILangdict, Langdict} from './langdict';
import {AcademicTerm, IAcademicTerm} from './academic-term';
import {environment} from '../../environments/environment';
import {CourseUnit, ICourseUnit} from './course-unit';

export class ICourse {
    coursesGroups: Iterable<string>;
    name: ILangdict;
    courseId: string;
    facultyId: string;
    fromDate: Date;
    status: string;
    term?: IAcademicTerm;
    courseUnits?: ICourseUnit[];
}

export interface IDetaildedCourse extends ICourse {
    language: { id: string, name: ILangdict };
    credits: {
        'default': number,
        // 'programmes': {}
    };
    reportType: {description: ILangdict, id: string};
    notes: ILangdict;
    description: ILangdict;
}

export class Course extends ICourse {

    coursesGroups: Set<string>;
    courseUnits: Array<CourseUnit>;

    constructor(obj: ICourse) {
        super();
        Object.assign(this, obj);
        this.courseId = obj.courseId;
        this.name = new Langdict(obj.name);
        this.coursesGroups = new Set(obj.coursesGroups);
        this.facultyId = obj.facultyId;
        this.fromDate = new Date(obj.fromDate);
        this.status = obj.status;
        this.term = new AcademicTerm(obj.term);
        if (obj.courseUnits) {
            this.courseUnits = obj.courseUnits.map(unit => new CourseUnit(unit));
        }
    }

    usoswebUrl() {
        return environment.usoswebUrl + 'kontroler.php?_action=katalog2/przedmioty/pokazPrzedmiot&prz_kod='
            + encodeURIComponent(this.courseId);
    }

    getPathFragment() {
        return [encodeURIComponent(this.courseId), encodeURIComponent(this.term.id)];
    }
}

export class DetailedCourse extends Course implements IDetaildedCourse {
    language: { id: string; name: Langdict };
    credits: { default: number };
    reportType: { description: Langdict; id: string };
    notes: Langdict;
    description: Langdict;

    constructor(obj: IDetaildedCourse) {
        super(obj);
        this.language = obj.language ? {id: obj.language.id, name: new Langdict(obj.language.name)} : null;
        this.reportType = obj.reportType ? {id: obj.reportType.id, description: new Langdict(obj.reportType.description)} : null;
        this.credits = obj.credits;
        this.notes = new Langdict(obj.notes);
        this.description = new Langdict(obj.description);
    }


}
